import { useEffect, useRef } from 'react';
import { ErrorHelperText } from './errorMessage.styles';

interface ErrorMessageProps {
  errorMessage?: string;
  clearErrors: () => void;
}

const ErrorMessage = ({ errorMessage, clearErrors }: ErrorMessageProps) => {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (errorMessage) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        clearErrors();
      }, 6000); // 6 seconds
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [errorMessage, clearErrors]);

  return (
    <>
      {errorMessage
        ?.split('. ')
        .map((msg, index, array) => (
          <ErrorHelperText
            key={index}
          >{`${msg}${index < array.length - 1 ? '.' : ''}`}</ErrorHelperText>
        ))}
    </>
  );
};

export default ErrorMessage;
